
import config from './config-devnet';
export default config;
